import { Form } from './Form'/* tslint:disable */
import { Step } from "./Step"
import { Text } from "./Text"

export class PublishedForm extends Form {
		RootFormId: number;
		RootFormGuid: string;
		VersionNumber: number;
		Password: string;
		FromDate: string;
		ToDate: string;
		Guid: string;
		Organisation: string;
		DataType: string;
		FormState: string;
		ShowSummary: boolean;
		Id: number;
		Name: string;
		Description: string;

		Steps: Step[];
		Texts: Text[];
}




// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/PublishedForm.ts